<section class="mod-page" data-module="profile">
  <header class="page-header">
    <div>
      <p class="eyebrow">Profile</p>
      <h1>My account</h1>
    </div>
    <button type="button" class="btn" (click)="logout()">Logout</button>
  </header>

  <app-toast [message]="message()" [tone]="messageTone()" (dismissed)="message.set(null)" />

  @if (officer(); as o) {
    <div class="grid-2">
      <section class="panel" style="text-align:center">
        <div style="width:96px;height:96px;border-radius:50%;margin:0 auto 1rem;display:grid;place-items:center;background:var(--module-soft);color:var(--module);font-size:1.6rem;font-weight:800">
          {{ initials() }}
        </div>
        <h2 style="font-size:1.25rem">{{ o.name }}</h2>
        <p class="muted">{{ roleLabel() }} · {{ o.department }}</p>
        <p class="muted" style="margin-top:.35rem">{{ o.district }} District</p>
      </section>

      <section class="panel">
        <h2 style="font-size:1rem;margin-bottom:.8rem">Employee Information</h2>
        <div class="toolbar form-grid" style="padding:0;border:0;box-shadow:none">
          <label>Name<input [(ngModel)]="name" /></label>
          <label>Employee ID<input [ngModel]="o.employeeId" disabled /></label>
          <label>Department<input [ngModel]="o.department" disabled /></label>
          <label>Role<input [ngModel]="roleLabel()" disabled /></label>
          <label>Email<input [(ngModel)]="email" /></label>
          <label>Phone<input [(ngModel)]="phone" /></label>
        </div>
        <div class="btn-row" style="margin-top:.85rem">
          <button type="button" class="btn primary" [disabled]="busy()" (click)="updateProfile()">
            {{ busy() ? 'Saving…' : 'Update Profile' }}
          </button>
        </div>

        <h2 style="font-size:1rem;margin:1.2rem 0 .7rem">Change Password</h2>
        <div class="toolbar" style="padding:0;border:0;box-shadow:none">
          <label>
            Current password
            <input
              type="password"
              autocomplete="current-password"
              [class.input-invalid]="currentPasswordError()"
              [(ngModel)]="currentPassword"
              (ngModelChange)="currentPasswordError.set(false)"
            />
          </label>
          <label>
            New password
            <input type="password" autocomplete="new-password" [(ngModel)]="newPassword" />
          </label>
        </div>
        @if (currentPasswordError()) {
          <p class="field-error">Current password is incorrect — the password was not changed.</p>
        }
        <div class="btn-row" style="margin-top:.75rem">
          <button type="button" class="btn" [disabled]="busy()" (click)="changePassword()">
            {{ busy() ? 'Saving…' : 'Change Password' }}
          </button>
        </div>
      </section>
    </div>
  }
</section>
